import { EditSpeakOptions } from '../EditSpeakOptions';
import { HelpPrime } from './HelpPrime';
import { InOutRules } from './InOutRules';
import { UsefulLinks } from './UsefulLinks';

/** UI for a variety of cascading rules */
export function PrimeArea() {
  return (<div style={{ display: 'grid', gridTemplateColumns: 'auto 220px' }}>
    <div>
      <HelpPrime />
      <br />
      <InOutRules />
    </div>
    <div style={{ textAlign: 'left' }}>
      Synthesizer Settings<br /><br />
      <EditSpeakOptions vertical={true} />

      <br />
      <hr />
      <br />

      <UsefulLinks />
    </div>
  </div>);
}
